"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var PrivacyPolicy_1 = require("containersRechargly/App/Policies/PrivacyPolicy");
var TermsAndConditions_1 = require("containersRechargly/App/Policies/TermsAndConditions");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Link_1 = __importDefault(require("shared/components/Link"));
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var PrivacyPolicy_2 = require("./PrivacyPolicy");
var TermsAndConditions_2 = require("./TermsAndConditions");
var CONTACT_MAIL = end2end_1.IS_RECHARGLY ? 'legal@rechargly.com' : 'info@hudled.com';
var PoliciesModal = function () {
    var location = (0, react_router_1.useLocation)();
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var acceptedTerms = !end2end_1.IS_RECHARGLY
        ? (profile === null || profile === void 0 ? void 0 : profile.privacyPolicyVersion) === PrivacyPolicy_2.privacyPolicyVersion && (profile === null || profile === void 0 ? void 0 : profile.termsAndConditionsVersion) === TermsAndConditions_2.termsAndConditionsVersion
        : (profile === null || profile === void 0 ? void 0 : profile.rechPrivacyPolicyVersion) === PrivacyPolicy_1.rechPrivacyPolicyVersion
            && (profile === null || profile === void 0 ? void 0 : profile.rechTermsAndConditionsVersion) === TermsAndConditions_1.rechTermsAndConditionsVersion;
    var allowedPaths = ['/policies/terms-and-conditions', '/policies/privacy-policy', '/policies'];
    var _a = __read((0, hooks_1.useSubmitter)('users', profile === null || profile === void 0 ? void 0 : profile.id, end2end_1.IS_RECHARGLY ? { rechPrivacyPolicyVersion: PrivacyPolicy_1.rechPrivacyPolicyVersion, rechTermsAndConditionsVersion: TermsAndConditions_1.rechTermsAndConditionsVersion } : { privacyPolicyVersion: PrivacyPolicy_2.privacyPolicyVersion, termsAndConditionsVersion: TermsAndConditions_2.termsAndConditionsVersion }), 2), userSubmitter = _a[0], isLoading = _a[1];
    if (allowedPaths.includes(location.pathname) || acceptedTerms || !(0, react_redux_firebase_1.isLoaded)(profile)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ label: "Terms And Conditions", open: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mx: 4 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, my: 5 }, { children: "Policy update" })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ my: 3 }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["We\u2019ve updated our ", (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/policies/terms-and-conditions", target: "_blank" }, { children: "Terms and Conditions" })), " and", ' ', (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/policies/privacy-policy", target: "_blank" }, { children: "Privacy Policy" })), ". Please take some time to review this."] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Once you\u2019ve read the updated Terms and Conditions and Privacy Policy please click ", (0, jsx_runtime_1.jsx)("strong", { children: "Accept" }), "."] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, mt: 1 }, { children: ["If you have questions, ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "mailto:".concat(CONTACT_MAIL), target: "_blank" }, { children: "contact us" })), "."] }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 5, mb: 3 }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ disabled: isLoading, onClick: function () { return userSubmitter({}, 'T&C Accepted'); } }, { children: "Accept" })) }))] })) })));
};
exports.default = PoliciesModal;
